// extracted by mini-css-extract-plugin
export default {"accordion":"JvfcUJGPKx1DGkAL7UCs","target":"b80g0l82RHR4uwzK5_Ms","targetIcon":"qJtwsqMOOQAK90h5O1U7","targetIconIsOpen":"UOOdUpV97AweYtFBCBqy","body":"dT2Vc2kxt7sNiOVd4lvi"};